import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { SessionRequest } from "../api/models/SessionRequest";

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};
const headers = new HttpHeaders().set("Content-Type", "application/json");

@Injectable()
export class UpplmLocationDetailsService {
    constructor(@Inject(HttpClient) private httpclient: HttpClient) {

    }


getValidationClientKeyId(apiurl: string): Observable < any > {
        let request = new SessionRequest();
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

}


//export class UpplmServices {
//    baseUrl = 'http://localhost:5000/api/';
//    public viewchangeValue: string;
//    public TransactionID: string | null;

//    constructor(private _http: HttpClient) {
//    }
//    viewChanged = new Subject();
//    getPlacards(): Observable<any> {
//        let url = this.baseUrl + 'Customers/1/Locations/1/Placards';
//        return this._http.get<any>(url);
//    }

//}